import { render } from "./DetailsSideList.vue?vue&type=template&id=663d1909"
import script from "./DetailsSideList.vue?vue&type=script&lang=ts"
export * from "./DetailsSideList.vue?vue&type=script&lang=ts"
script.render = render

export default script